import styled, { css } from 'styled-components';
import { focusVisibleWithOutline } from '../utils/focus-indicator';
const smWhiteStyles = ({
  $smWhite,
  theme
}) => $smWhite ? css`
        @media (max-width: 767px) {
          svg path {
            fill: ${theme.palette.actionablePrimary};
          }
        }
      ` : '';
export const LogoSwitcher = styled.div`
  > :nth-child(1) {
    display: ${props => props.$logoMobileLarge ? 'none' : 'block'};

    @media (min-width: ${props => props.theme.mediaXs}) {
      display: none;
    }
  }
  > :nth-child(2) {
    display: ${props => props.$logoMobileLarge ? 'block' : 'none'};
    @media (min-width: ${props => props.theme.mediaXs}) {
      display: block;
    }
    @media (min-width: ${props => props.theme.mediaSm}) {
      display: none;
    }
  }
  > :nth-child(3) {
    display: none;
    @media (min-width: ${props => props.theme.mediaSm}) {
      display: block;
    }
  }
  ${smWhiteStyles};
`;
export const CloseButton = styled.button`
  background: transparent;
  border: none;
  font-weight: 500;
`;
export const Nav = styled.nav`
  @media (min-width: ${({
  theme
}) => theme.mediaSmHeader}) {
    // @README Spacing required to correctly render the :focus-visible
    padding: calc(${({
  theme
}) => theme.focusOffset} * 2);
  }
`;
export const Label = styled.label`
  ${focusVisibleWithOutline({
  offset: 'default'
})}
`;
//# sourceMappingURL=styles.js.map